export default {
    dev: {
        global: {
            url: 'https://dev-www.nexon.com',
        },
        one: {
            url: 'https://dev-one.nexon.com',
        },
        th: {
            url: 'https://dev-th.nexon.com',
        },
        tw: {
            url: 'https://dev-tw.nexon.com',
        },
        sea: {
            url: 'https://dev-sea.nexon.com',
        },
        japan: {
            url: 'https://dev-japan.nexon.com',
        },
    },
    testPre: {
        global: {
            url: 'https://test-pre-www.nexon.com',
        },
        one: {
            url: 'https://test-pre-one.nexon.com',
        },
        th: {
            url: 'https://test-pre-th.nexon.com',
        },
        tw: {
            url: 'https://test-pre-tw.nexon.com',
        },
        sea: {
            url: 'https://test-pre-sea.nexon.com',
        },
        japan: {
            url: 'https://test-pre-japan.nexon.com',
        },
    },
    test: {
        global: {
            url: 'https://test-www.nexon.com',
        },
        one: {
            url: 'https://test-one.nexon.com',
        },
        th: {
            url: 'https://test-th.nexon.com',
        },
        tw: {
            url: 'https://test-tw.nexon.com',
        },
        sea: {
            url: 'https://test-sea.nexon.com',
        },
        japan: {
            url: 'https://test-japan.nexon.com',
        },
    },
    pre: {
        global: {
            url: 'https://pre-www.nexon.com',
        },
        one: {
            url: 'https://pre-one.nexon.com',
        },
        th: {
            url: 'https://pre-th.nexon.com',
        },
        tw: {
            url: 'https://pre-tw.nexon.com',
        },
        sea: {
            url: 'https://pre-sea.nexon.com',
        },
        japan: {
            url: 'https://pre-japan.nexon.com',
        },
    },
    prod: {
        global: {
            url: 'https://www.nexon.com',
        },
        one: {
            url: 'https://one.nexon.com',
        },
        th: {
            url: 'https://th.nexon.com',
        },
        tw: {
            url: 'https://tw.nexon.com',
        },
        sea: {
            url: 'https://sea.nexon.com',
        },
        japan: {
            url: 'https://japan.nexon.com',
        },
    },
};
